import { FC, useState } from 'react'
import { SiteModel } from '../../../core/_models'
import { formatTRY } from '_metronic/partials/widgets/tables/TenderListWidget'
type Props = {
    site: SiteModel
}
const AdvanceAmountCell: FC<Props> = ({ site }) => {


    return (
        <div className='d-flex align-items-center'>
            <div className='flex-grow-1'>
                {site.advanceAmountTry !== null && site.advanceAmountTry !== undefined && 
                formatTRY(site.advanceAmountTry.toFixed(2))}
            </div>
        </div>
    )
}
export { AdvanceAmountCell }
